import { BOX_SHADOWS, COLORS } from 'constants/index';
import typography from '../typography';

const MuiButton = {
  root: {
    ...typography.button,
    backgroundColor: COLORS.WHITE,
    borderRadius: '4px',
    height: '36px',
    boxShadow: 'none',
    padding: '10px 14px',
    minWidth: '85px',
    '&:hover': {
      boxShadow: BOX_SHADOWS.default,
    }
  },
  text: {
    minWidth: '87px',
  },
  containedPrimary: {
    color: COLORS.WHITE,
    backgroundColor: COLORS.BLUE,
    boxShadow: 'none',
  },
  label: {
    ...typography.button,
  },
  containedSecondary: {
    color: COLORS.BLACK_LIGHT,
    backgroundColor: COLORS.GRAY,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: COLORS.WHITE,
    }
  },
  outlined: {
    color: COLORS.BLUE,
    padding: '10px 14px',
    border: `1px solid ${COLORS.GRAY_BORDER}`,
    '&:hover': {
      borderColor: COLORS.GRAY_BORDER,
      backgroundColor: COLORS.OFF_WHITE,
    }
  },
  outlinedSizeSmall: {
    width: '75px',
    minWidth: '75px',
  },
  outlinedSizeLarge: {
    paddingTop: '24px',
    paddingBottom: '24px',
    width: '100%',
    border: `1px solid ${COLORS.BLACK_08}`,
    height: 'auto',
  },
  iconSizeSmall: {
    '& > *:first-child': {
      fontSize: '27px'
    },
  },
};

export default MuiButton;